import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ThemeContext } from '../../context/ThemeContext.js';
import OmButton from '../forms/OmButton.js';
import OmDropdownField from '../forms/OmDropdownField.js';
import OmInputFieldWrapper from '../forms/OmInputFieldWrapper.js';
import OmRadioButtonGroup from '../forms/OmRadioButtonGroup.js';
import PastPerformanceResultCard from './PastPerformanceResultCard.js';

import {
    setFund,
    setContributionFrequency,
    setInvestmentAmount,
    setInvestmentTerm,
    setRefData,
    pastPerfomanceCalculatorResults,
} from '@om/redux/actions/pastPerformanceCalculator/pastPerformanceCalculator';

import {
    getFund,
    getContributionFrequency,
    getInvestmentAmount,
    getInvestmentTerm,
    getCalculatorEnabled,
    getShowResultsCard,
    getFunds,
    getInvestmentTerms,
} from '@om/redux/selectors/pastPerformanceCalculator/pastPerformanceCalculator';

import './PastPerformanceCalculator.scss';

const PastPerformanceCalculator = ({
    slot,
    data,
}) => {
    const theme = React.useContext(ThemeContext);
    const dispatch = useDispatch();
    const inputDisabled = false;
    const {
        fund,
        funds,
        contributionFrequency,
        investmentAmount,
        investmentTerm,
        investmentTerms,
        calculatorEnabled,
        showResultsCard,
    } = useSelector(
        createStructuredSelector({
            fund : getFund,
            funds : getFunds,
            contributionFrequency: getContributionFrequency,
            investmentAmount : getInvestmentAmount,
            investmentTerm : getInvestmentTerm,
            investmentTerms : getInvestmentTerms,
            calculatorEnabled: getCalculatorEnabled,
            showResultsCard: getShowResultsCard,
        })
    );

    useEffect(() => {
        dispatch(setRefData(data.allPastPerformanceData.nodes));
    }, [dispatch, data]);

    return (
        <div slot={slot} className={`${theme} past-perf-calc`}>
            <div className="form">
                <div className="col">
                    <div className="field-width">
                        <OmDropdownField
                            useNativeMobileDropdown
                            required="true"
                            size="small"
                            placeholder="Fund Name"
                            name="fundName"
                            align="left"
                            disabled={inputDisabled}
                            onSelectHandler={e => dispatch(setFund(e.detail.value))}
                            reduxValue={fund}
                            options={funds}
                        />

                        <OmRadioButtonGroup
                            value={contributionFrequency}
                            vertical={false}
                            smallLabel={true}
                            label="How often you would have made contribution?"
                            onSelectionHandler={e => dispatch(setContributionFrequency(e.detail))}
                        >
                            <li value="ONCE_OFF">Once Off</li>
                            <li value="MONTHLY">Monthly</li>
                        </OmRadioButtonGroup>
                    </div>
                </div>
                <div className="col">
                    <div className="field-width">
                        <OmInputFieldWrapper
                            placeholder="Investment Amount (Rands)"
                            required
                            size="full"
                            name="investmentAmount"
                            reduxValue={investmentAmount}
                            disabled={inputDisabled}
                            keyboardMode="numeric"
                            prefixString="R"
                            persistHandler={(e) => dispatch(setInvestmentAmount(e))}
                        />

                        <OmDropdownField
                            useNativeMobileDropdown
                            required="true"
                            size="small"
                            placeholder="Investment term (Years)"
                            name="investmentTerm"
                            align="left"
                            disabled={inputDisabled}
                            onSelectHandler={e => dispatch(setInvestmentTerm(e.detail.value))}
                            reduxValue={investmentTerm}
                            options={investmentTerms}
                        />
                    </div>
                </div>
            </div>
            <div className="result">
                <div className="btn-wrapper">
                    <OmButton
                        type="primary"
                        size="large"
                        text="Calculate"
                        iconName="chevron_right"
                        disabled={!calculatorEnabled}
                        onClick={() => dispatch(pastPerfomanceCalculatorResults())}
                    />
                </div>
                <div className="card-wrapper">
                    {
                        showResultsCard && <PastPerformanceResultCard/>
                    }
                </div>
            </div>
        </div>
    )
}

export default PastPerformanceCalculator;
